export const batch = [
    {
        cols: [
            {
                content: {
                    html: '<h1>TITULEK</h1>',
                    style: {
                        textAlign: 'left',
                    },
                },
                style: {
                    width: '100%',
                },
            },
        ],
    },
];

export default batch;
